<template>
  <div>
    <b-form-group>
      <b-form-checkbox
        v-model="enabled"
        :selected="enabled"
        class="mb-1"
      >
        {{ label }}
      </b-form-checkbox>
    </b-form-group>

    <div :class="{ 'disabled-content': !enabled && selectedItems.length }">
      <b-button
        variant="primary"
        size="sm"
        class="mb-1"
        :disabled="Boolean(!enabled && selectedItems.length)"
        @click="showModal = true"
      >
        <feather-icon
          icon="PlusIcon"
          size="16"
          class="mr-50"
        />
        {{ $t('campaigns.openrtb.add_item') }}
      </b-button>

      <div
        v-if="selectedItems.length"
        class="selected-items"
      >
        <div
          v-for="(item, index) in selectedItems"
          :key="index"
          class="selected-item d-flex align-items-center mb-1"
        >
          <span class="mr-1">{{ item.partner }} -> {{ item.source }}</span>
          <b-button
            variant="flat-danger"
            size="sm"
            class="ml-auto"
            @click="removeItem(index)"
          >
            <feather-icon
              icon="XIcon"
              size="16"
            />
          </b-button>
        </div>
      </div>
    </div>

    <!-- Модальное окно выбора -->
    <b-modal
      v-model="showModal"
      :title="$t('campaigns.openrtb.select_item')"
      size="lg"
      hide-footer
    >
      <div v-if="!selectedPartner">
        <!-- Первый этап: выбор DSP партнера -->
        <b-form-group>
          <b-form-input
            v-model="partnerSearch"
            :placeholder="$t('campaigns.openrtb.search_partner')"
            class="mb-1"
          />
        </b-form-group>

        <div
          class="partners-list"
          style="max-height: 300px; overflow-y: auto;"
        >
          <div
            v-for="partner in filteredPartners"
            :key="partner.id"
            class="partner-item p-1 cursor-pointer"
            :class="{ 'bg-light': selectedPartnerId === partner.id }"
            @click="selectPartner(partner)"
          >
            {{ partner.name }}
          </div>
        </div>
      </div>

      <div v-else>
        <!-- Второй этап: выбор источника -->
        <div class="d-flex align-items-center mb-1">
          <b-button
            variant="flat-secondary"
            size="sm"
            class="mr-1"
            @click="backToPartners"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              size="16"
              class="mr-50"
            />
            {{ $t('campaigns.openrtb.back') }}
          </b-button>
          <span class="text-muted">{{ selectedPartner.name }}</span>
        </div>

        <b-form-group>
          <b-form-input
            v-model="sourceSearch"
            :placeholder="$t('campaigns.openrtb.search_source')"
            class="mb-1"
          />
        </b-form-group>

        <div
          class="sources-list"
          style="max-height: 300px; overflow-y: auto;"
        >
          <div
            v-for="source in filteredSources"
            :key="source.id"
            class="source-item p-1 cursor-pointer"
            :class="{ 'bg-light': selectedSourceId === source.id }"
            @click="selectSource(source)"
          >
            {{ source.name }}
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormGroup, BFormCheckbox, BFormInput, BButton, BModal,
} from 'bootstrap-vue'

export default {
  name: 'OpenRtbListBlock',
  components: {
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BButton,
    BModal,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      partnerSearch: '',
      sourceSearch: '',
      selectedPartner: null,
      selectedPartnerId: null,
      selectedSourceId: null,
      // Моковые данные для примера
      partners: [
        { id: 1, name: 'DSP Partner 1' },
        { id: 2, name: 'DSP Partner 2' },
        { id: 3, name: 'DSP Partner 3' },
      ],
      sources: {
        1: [
          { id: 1, name: 'Source 1.1' },
          { id: 2, name: 'Source 1.2' },
        ],
        2: [
          { id: 3, name: 'Source 2.1' },
          { id: 4, name: 'Source 2.2' },
        ],
        3: [
          { id: 5, name: 'Source 3.1' },
          { id: 6, name: 'Source 3.2' },
        ],
      },
    }
  },
  computed: {
    enabled: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:model-value', value)
      },
    },
    selectedItems: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    filteredPartners() {
      if (!this.partnerSearch) return this.partners
      const search = this.partnerSearch.toLowerCase()
      return this.partners.filter(p => p.name.toLowerCase().includes(search))
    },
    filteredSources() {
      if (!this.selectedPartner) return []
      if (!this.sourceSearch) return this.sources[this.selectedPartner.id] || []
      const search = this.sourceSearch.toLowerCase()
      return (this.sources[this.selectedPartner.id] || []).filter(s => s.name.toLowerCase().includes(search))
    },
  },
  watch: {
    modelValue(newValue) {
      this.$emit('enabled-change', newValue)
    },
  },
  methods: {
    selectPartner(partner) {
      this.selectedPartner = partner
      this.selectedPartnerId = partner.id
      this.sourceSearch = ''
    },
    backToPartners() {
      this.selectedPartner = null
      this.selectedPartnerId = null
      this.selectedSourceId = null
      this.sourceSearch = ''
    },
    selectSource(source) {
      this.selectedItems = [
        ...this.selectedItems,
        {
          partner: this.selectedPartner.name,
          source: source.name,
          partnerId: this.selectedPartner.id,
          sourceId: source.id,
        },
      ]
      this.showModal = false
      this.backToPartners()
    },
    removeItem(index) {
      this.selectedItems = this.selectedItems.filter((_, i) => i !== index)
    },
  },
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
.selected-items {
  margin-top: 1rem;
}
.selected-item {
  padding: 0.5rem;
  border: 1px solid #ebe9f1;
  border-radius: 0.428rem;
}
.disabled-content {
  opacity: 0.5;
  pointer-events: none;
}
</style>
